import React from 'react';
import * as s from './styled-scroll-list';

// Remove o prefixo "BRASIL - " do nome de zonas vindo do backend.
// Todas as zonas são brasileiras hoje, o prefixo só polui a UI.
const formatZoneName = (name = '') => name.replace(/^BRASIL\s*-\s*/i, '');

// Chevron lucide pra modo $cco (estilo X/Twitter)
const ChevronRight = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="m9 6 6 6-6 6" />
  </svg>
);

const ScrollList = ({
  list = [],
  onClick,
  selected,
  type,
  filtered,
  $cco = false,
  counts = {},
  // { [itemId]: { ucha: N, eba: M } } — contagem por tipo de equipamento.
  // Quando presente pro item, exibe pills coloridos (laranja UCHA / azul
  // EBA) em vez do count neutro. Convencao de cor do app.
  typeCounts = {},
  alertCounts = {}, // { [itemId]: numero de parques em ALERTA ativo } —
  //                   renderiza badge vermelho ao lado do contador total
  //                   quando > 0. Operador identifica em qual estado/cliente
  //                   esta "pegando fogo" sem percorrer overlay de alertas.
  onHoverItem, // (item) => void — chamado no mouseenter pra pan-preview
  onHoverLeave, // () => void — chamado no mouseleave (cancela debounce)
}) => {
  return (
    <s.Container>
      {!!list.length && (
        <s.ScrollBarTitle $cco={$cco}>
          {type === 'customer' ? 'DESTACAR CLIENTE' : 'SELECIONE O ESTADO'}
        </s.ScrollBarTitle>
      )}

      <s.ZoneScrollContainer $cco={$cco}>
        {list.length
          ? list.map((item) => {
              const displayName =
                type === 'zona' ? formatZoneName(item.name) : item.name;
              const count = counts[item.id];
              const tc = typeCounts[item.id];
              const hasTypeCounts =
                tc && ((tc.ucha || 0) > 0 || (tc.eba || 0) > 0);
              const alertCount = alertCounts[item.id];
              const isSelected = selected(item);
              return (
                <s.ListLabel
                  key={item.id}
                  type="button"
                  selected={isSelected}
                  $cco={$cco}
                  onClick={() => onClick(item)}
                  onMouseEnter={
                    onHoverItem ? () => onHoverItem(item) : undefined
                  }
                  onMouseLeave={onHoverLeave || undefined}
                  title={item.name}
                >
                  <span className="name">{displayName}</span>
                  {$cco && (
                    <span
                      style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: 8,
                      }}
                    >
                      {hasTypeCounts ? (
                        <>
                          {(tc.ucha || 0) > 0 && (
                            <span className="count-ucha" title={`${tc.ucha} UCHA`}>
                              {tc.ucha}
                            </span>
                          )}
                          {(tc.eba || 0) > 0 && (
                            <span className="count-eba" title={`${tc.eba} EBA`}>
                              {tc.eba}
                            </span>
                          )}
                        </>
                      ) : (
                        count != null && <span className="count">{count}</span>
                      )}
                      {alertCount > 0 && (
                        <span
                          className="alert-count"
                          title={`${alertCount} em alerta`}
                        >
                          {alertCount}
                        </span>
                      )}
                      <span className="chev">
                        <ChevronRight />
                      </span>
                    </span>
                  )}
                </s.ListLabel>
              );
            })
          : !!filtered && (
              <s.Empty>
                {type === 'zona'
                  ? `Zona não encontrada`
                  : `Cliente não encontrado`}
              </s.Empty>
            )}
      </s.ZoneScrollContainer>
    </s.Container>
  );
};

export default ScrollList;
